<template>
  <template v-for="(item, index) in menuItems" :key="index">
    <el-sub-menu v-if="item.childlist && item.childlist.length" :index="item.id">
      <template #title>{{ item.name }}</template>
      <recursive-menu-item 
        :menu-items="item.childlist"
        @click-item="$emit('click-item', $event)"
      />
    </el-sub-menu>
    <el-menu-item 
      v-else 
      :index="item.id"
      @click="$emit('click-item', item.id)"
    >
      {{ item.name }}
    </el-menu-item>
  </template>
</template>

<script>
export default {
  name: 'RecursiveMenuItem',
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  emits: ['click-item']
}
</script>
